export default {
    locationcd: '事業所',
    thatday: '日付',
    previousbalance: '前日残高',
    depositamount: '当日入金額',
    withdrawalamount: '当日出金額',
    balance: '当日残高'
};
